export default "__VITE_ASSET__90RWZuiN__"